export default [
    {
        path: 'egresos',
        name: 'pos.egresos',
        component: () => import('@/views/pos/egresos/GastosPosLayout.vue'),
        children: [
            {
                path: 'gastos',
                name: 'pos.egresos.gastos',
                component: () => import('@/views/pos/egresos/GastosSucursalHome.vue'),
                redirect: { name: 'pos.egresos.gastos.list' },
                children: [

                    { path: '', name: 'pos.egresos.gastos.list', component: () => import('@/views/pos/egresos/components/GastosPorCategoriaList.vue') },

                    { path: 'detail', name: 'pos.egresos.gastos.detail', component: () => import('@/views/empresa/sucursales/egresos/GastosSucursalList.vue') },
                ],
            },
            {
                path: 'gastos/nuevo',
                name: 'pos.egresos.gastos.nuevo',
                component: () => import('@/views/pos/egresos/GastosPosRegistrar.vue'),
            },
            {
                path: 'gastos/:id',
                name: 'pos.egresos.gastos.update',
                component: () => import('@/views/pos/egresos/GastosPosUpdate.vue'),
            },
        ]
    }
];
